<template>
  <div>
    <v-row class="mb-3" no-gutters align="start">
      <v-col class="shrink">
        <v-checkbox hide-details class="ma-0" @change="$emit('agree', $event)" />
      </v-col>
      <v-col class="grow">
        {{ $t('message.save_card_agreement.text_1') }}
        <a @click="dialog = true">{{ $t('message.save_card_agreement.link_text') }}</a>
        {{ $t('message.save_card_agreement.text_2') }}
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="640" scrollable>
      <v-card>
        <v-card-title class="headline">{{ $t('message.save_card_agreement.terms.title') }}</v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <p v-html="$t('message.save_card_agreement.terms.paragraph_1')"></p>
          <p v-html="$t('message.save_card_agreement.terms.paragraph_2')"></p>

          <ol class="mb-3">
            <li>
              <strong v-html="$t('message.save_card_agreement.terms.list.1.title')"></strong>
              <ol>
                <li v-html="$t('message.save_card_agreement.terms.list.1.list.a')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.1.list.b')"></li>
              </ol>
            </li>
            <li>
              <strong v-html="$t('message.save_card_agreement.terms.list.2.title')"></strong>
              <ol>
                <li v-html="$t('message.save_card_agreement.terms.list.2.list.a')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.2.list.b')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.2.list.c')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.2.list.d')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.2.list.e')"></li>
              </ol>
            </li>
            <li>
              <strong v-html="$t('message.save_card_agreement.terms.list.3.title')"></strong>
              <ol>
                <li v-html="$t('message.save_card_agreement.terms.list.3.list.a')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.3.list.b')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.3.list.c')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.3.list.d')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.3.list.e')"></li>
              </ol>
            </li>

            <li>
              <strong v-html="$t('message.save_card_agreement.terms.list.4.title')"></strong>
              <p v-html="$t('message.save_card_agreement.terms.list.4.paragraph')"></p>
            </li>

            <li>
              <strong v-html="$t('message.save_card_agreement.terms.list.5.title')"></strong>
              <ol>
                <li v-html="$t('message.save_card_agreement.terms.list.5.list.a')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.5.list.b')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.5.list.c')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.5.list.d')"></li>
                <li v-html="$t('message.save_card_agreement.terms.list.5.list.e')"></li>
              </ol>
            </li>
          </ol>

          <p v-html="$t('message.save_card_agreement.terms.last_update')"></p>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SaveCardTerms',
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped></style>
